import { User } from 'lib/generated/graphql';
import InviteLinkBox from '../InviteLinkBox';
import SuccessfulInvites from '../SuccessfulInvites';

const BuilderInvites = ({ user }: { user: User }) => {
  return (
    <div data-testid="builder-invites">
      <InviteLinkBox user={user} referralType="BUILDER" />
      <SuccessfulInvites user={user} referralType="BUILDER" />
    </div>
  );
};

export default BuilderInvites;
